
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"112.502","height":"50.944","viewBox":"0 0 112.502 50.944"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',[_c('path',{attrs:{"id":"backDrop","d":"M101.889 50.944H10.613A10.51 10.51 0 010 40.331V10.613A10.51 10.51 0 0110.613 0h91.275A10.51 10.51 0 01112.5 10.613v29.718a10.51 10.51 0 01-10.611 10.613z","fill":"#292e35"}}),_c('circle',{staticClass:"b",attrs:{"id":"blank","cx":"13.373","cy":"13.373","transform":"translate(71.535 12.099)","r":"13.373"}}),_c('circle',{staticClass:"b",attrs:{"id":"blank","cx":"13.373","cy":"13.373","transform":"translate(9.34 12.099)","r":"13.373"}}),_c('g',{attrs:{"transform":"translate(36.51 8.278)"}},[_c('circle',{attrs:{"cx":"17.194","cy":"17.194","opacity":".2","fill":"#ebb111","r":"17.194"}}),_c('circle',{attrs:{"cx":"13.373","cy":"13.373","transform":"translate(3.821 3.821)","fill":"#ebb111","r":"13.373"}}),_c('path',{staticClass:"b",attrs:{"d":"M16.983 19.316h-.425a1.37 1.37 0 01-1.275-1.273v-6.368a1.37 1.37 0 011.274-1.274h.426a1.37 1.37 0 011.274 1.274v6.368a1.37 1.37 0 01-1.274 1.273zM16.983 24.411h-.425a1.37 1.37 0 01-1.275-1.274V22.5a1.37 1.37 0 011.274-1.273h.426a1.37 1.37 0 011.274 1.274v.637a1.224 1.224 0 01-1.274 1.273z"}})])])])
          )
        }
      }
    